/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { lazy, Suspense } from 'react';
import { BrowserRouter, useRoutes, RouteObject } from 'react-router-dom';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { getLandingPageRoute } from '@pages/LandingPage';
import { getPlaceholderPageRoute } from '@pages/Placeholder';
import { getVendingMachinePageRoute } from '@pages/VendingMachinePage';
import { getProductPageRoute } from '@pages/ProductPage';
import { getBuyInsurancePageRoute } from '@pages/BuyInsurancePage';
import { getMyProfilePageRoute } from '@pages/MyProfilePage';
import { getActualPoliciesPageRoute } from '@pages/ActualPolicyPage';
import { getPolicyDetailPageRoute } from '@pages/PolicyDetailPage';
import { getNomineeKYCPageRoute } from '@pages/NomineeKYCPage';
import { getSignInPageRoute } from '@pages/SignInPage';
import ScrollToTop from './ScrollToTop';
import { useSMAppNavigator } from './machines/pageContent';

const _handleDropDownItemClick = (item: any) => {};

export const AppNavigator = (): JSX.Element => {
  const { appNavigatorSend, appNavigatorState, appNavigatorMachine } =
    useSMAppNavigator({});

  if (appNavigatorState?.matches('RENDER_PAGE')) {
    const {
      brandLogo,
      brandLogoLink,
      brandTitle,
      sidebarItems,
      routes,
      orgName,
      orgUrl,
      copyrightStartYear,
      whoami,
      userName,
      userImage,
      dropdownItems,
      footerSection,
    } = { ...(appNavigatorState?.event?.data?.value || {}) };
    const props = {
      brandLogo,
      brandLogoLink,
      brandTitle,
      items: sidebarItems,
      routes,
      orgName,
      orgUrl,
      copyrightStartYear,
      whoami,
      userName,
      userImage,
      dropdownItems,
      footerSections: footerSection,
      onDropDownItemClick: _handleDropDownItemClick,
    };

    const getAllRoutes = (): RouteObject[] => {
      return [
        getLandingPageRoute(props),
        getPlaceholderPageRoute(props),
        getVendingMachinePageRoute(props),
        getProductPageRoute(props),
        getBuyInsurancePageRoute(props),
        getActualPoliciesPageRoute(props),
        getPolicyDetailPageRoute(props),
        getNomineeKYCPageRoute(props),
        getMyProfilePageRoute(props),
        getSignInPageRoute(props),
      ];
    };

    const RouterConfig = () => {
      const routes = useRoutes(getAllRoutes());
      return routes;
    };
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div></div>}>
          <RouterConfig />
        </Suspense>
      </BrowserRouter>
    );
  }
  if (appNavigatorState?.matches('GET_PAGE_CONTENT')) {
    console.log('get page content');
    return <div />;
  }
  return <></>;
};
